import styled from '@emotion/styled';
import React, { useState } from 'react';
import { Tabs, TabList, Tab } from 'aquilla/core/molecules/Tabs';
import { Spacings, mediaQuery } from '@styles/index';
import { useRouter } from 'next/router';
import pushRoute from '@utils/pushRoute';
import { segment } from '@actions/analytics';
import { BATCH_TAB_INDEX, TabWrapperID } from './constants';

const TabsWrapper = styled.div`
  position: sticky;
  top: 128px;
  padding: ${Spacings.SPACING_11B} calc((100% - 1136px) / 2) 0;
  border-bottom: 1px solid var(--color-divider);
  background-color: var(--color-base-1);
  z-index: 1;

  ${mediaQuery.uptoTablet} {
    width: 100%;
    top: -${Spacings.SPACING_2B};
    padding: ${Spacings.SPACING_20B} ${Spacings.SPACING_4B}
      ${Spacings.SPACING_4B};
  }

  ${mediaQuery.uptoMobile} {
    top: ${Spacings.SPACING_12B};
    padding: 0 ${Spacings.SPACING_4B} 0;
  }
`;

const getEducatorPageRoute = (tabData, authorID) => {
  switch (tabData.page) {
    case 'educator_batches':
      return {
        href: tabData.href,
        as: `/${authorID}/batches`
      };
    case 'educator_courses':
      return {
        href: tabData.href,
        as: `/${authorID}/courses?type=popular`
      };
    case 'educator_free_classes':
      return {
        href: tabData.href,
        as: `/${authorID}/special-classes?type=latest`
      };
    case 'educator_about':
      return {
        href: tabData.href,
        as: `/${authorID}/about`
      };
    default:
      break;
  }
};

const tabsData = [
  {
    id: 'educator_batches_tab',
    label: 'Batches',
    page: 'educator_batches',
    href: '/[authorID]/batches'
  },
  {
    id: 'educator_courses_tab',
    label: 'Courses',
    page: 'educator_courses',
    href: '/[authorID]/courses',
    query: {
      type: 'popular'
    }
  },
  {
    id: 'educator_free_classes_tab',
    label: 'Free classes',
    page: 'educator_free_classes',
    href: '/[authorID]/special-classes',
    query: {
      type: 'latest'
    }
  },
  {
    id: 'educator_about_tab',
    label: 'About',
    page: 'educator_about',
    href: '/[authorID]/about'
  }
];

const TabLabel = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_1B};
  align-items: center;
`;
const EducatorTabs = ({ tabIndex = BATCH_TAB_INDEX, isExEducator = false }) => {
  const { query } = useRouter();
  const { authorID } = query;
  const [currentTabIndex, setTabIndex] = useState(tabIndex);
  const handleOnChange = (index) => {
    const currentSelectedTabData = tabsData[index];
    const route = getEducatorPageRoute(currentSelectedTabData, authorID);

    if (tabIndex !== index) {
      // trigger event
      segment.track('Educator - Profile Tab Clicked', {
        entity_type: currentSelectedTabData.label
      });
      pushRoute(
        {
          pathname: currentSelectedTabData.href,
          query: currentSelectedTabData.query
        },
        route.as
      );
      setTabIndex(index);
    }
  };

  let tabList = tabsData;
  if (isExEducator) tabList = tabList.slice(0, 3);

  return (
    <TabsWrapper id={TabWrapperID}>
      <Tabs onChange={handleOnChange} index={currentTabIndex}>
        <TabList>
          {tabList.map((tab) => {
            return (
              <Tab key={tab.id} id={tab.id}>
                <TabLabel>{tab.label}</TabLabel>
              </Tab>
            );
          })}
        </TabList>
      </Tabs>
    </TabsWrapper>
  );
};

export default EducatorTabs;
